import React from 'react';
import PropTypes from 'prop-types';

import styles from './Content.scss';

const Content = ({ children }) => (
  <div className={`${styles.Content}`}>
    {children}
  </div>
);

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]).isRequired
};

export default Content;



// WEBPACK FOOTER //
// ./src/containers/Content/Content.js